<template>
    <bareme-etape-3></bareme-etape-3>
</template>

<script>


import BaremeEtape3 from '@/components/bareme/etapes/Etape3.vue';

export default {
  name: 'BaremeAjuste',
  components: { BaremeEtape3 },
};
</script>

<style scoped>

</style>
